export const EquipmentProblemPage = () => {
    return <>EquipmentProblemPage</>
}